import { useEffect, useState } from "react"
import Logo from "@/assets/logo-with-text.png";
import { useLocation, useNavigate } from "react-router";
import { AuthResponse } from "../types/common";
import appStore from "../stores/appStore";
import LoginModal from "../pages/AccountPage/components/LoginModal";
import CityModal from "./CityModal";
import { observer } from "mobx-react-lite";
import NewYearLights from "./NewYearLights";

const HeaderMobile = () => {
    useEffect(() => {
    if(window.location.pathname == '/' || appStore.categories.length == 0) appStore.getCategories();
    if(window.location.pathname == '/' || appStore.cities.length == 0) appStore.getCities();
    }, []);

    const navigate = useNavigate();

    const location = useLocation();


    const [isOpenModalLogin, setIsOpenModalLogin] = useState((['/profile', '/profile/settings'].includes(location.pathname) && !appStore.isLoginIn));

      const [isOpenModal, setIsOpenModal] = useState(!appStore.selectedCity);


      useEffect(() => {
        console.log("is login in", `${location.pathname} ${appStore.isLoginIn}`);
        
        setIsOpenModalLogin((['/profile', '/profile/settings'].includes(location.pathname) && !appStore.isLoginIn));
      }, [location.pathname])

    return (
        <header>
      <NewYearLights></NewYearLights>

            <div className="flex h-[80px] border-b border-[#C6C6C8BF] justify-center items-center w-full">
              <a href="/" className="w-100 flex items-center justify-center">
              <img
          src={Logo}
          className="w-[50%] flex-shrink-0 cursor-pointer"
          onClick={() => navigate("/")}
          alt="Логотип компании"
        />
              </a>
            
            </div>

          <CityModal isOpen={isOpenModal} onClose={() => setIsOpenModal(false)} isMobile={true} />

        <LoginModal isOpen={isOpenModalLogin} onClose={() => setIsOpenModalLogin(false)} onAuthSuccess={(data: AuthResponse) => appStore.onAuthCompleted(data)}></LoginModal>
        </header>
    )
}

export default observer(HeaderMobile);